import React from 'react'
import { browserHistory } from 'react-router'
import UsersTable from '../../../components/Admin/Users/UsersTable'
import { user } from '../../../core/controllers/user';
import NavLink from '../../../components/Routes/NavLink';

import NewManagersCard from '../../../components/Admin/Users/NewManagersCard'
import InactiveUsersCard from '../../../components/Admin/Users/InactiveUsersCard'
import NeedApprovalManagersCard from '../../../components/Admin/Users/NeedApprovalManagersCard'
import TotalManagersCard from '../../../components/Admin/Users/TotalManagersCard'

export default class AdminUsers extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        user.getUserDataWithCallback(function(response) {
            if (user.userInfo.user_type_alias != 'super-admin') {
                browserHistory.replace('/');
            }
        });
    }
    render(){
        return (
            <div>
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3">
                            <span class="main-page-header-title">Managers</span>
                        </div>
                        <div class="col-md-2 col-md-offset-7">
                            <NavLink to={"/admin/user/new"}>
                                <button type="button" id="add-manager" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                    Add Manager
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <NewManagersCard clickable={false}/>
                    <InactiveUsersCard clickable={false}/>
                    <NeedApprovalManagersCard clickable={false}/>
                    <TotalManagersCard clickable={false}/>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Managers</h4>
                                <p class="category">Complete list of all property managers</p>
                            </div>
                            <div class="content">
                                <UsersTable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/Admin/Users/AdminUsers.jsx